export const isPersonEnu = {
  1: "个人",
  2: "企业",
};
